import { render, staticRenderFns } from "./EntregaDocumentos.vue?vue&type=template&id=79fc01e0"
import script from "./EntregaDocumentos.vue?vue&type=script&lang=js"
export * from "./EntregaDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79fc01e0')) {
      api.createRecord('79fc01e0', component.options)
    } else {
      api.reload('79fc01e0', component.options)
    }
    module.hot.accept("./EntregaDocumentos.vue?vue&type=template&id=79fc01e0", function () {
      api.rerender('79fc01e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/EntregaDocumentos.vue"
export default component.exports